"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_document_elements_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../../main");
const document_1 = require("../../document");
const update_document_elements_1 = require("../../../../../api/calls/document/update_document_elements");
exports.update_document_elements_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/update_document_elements_thunk", (arg, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data, callback, suppressModal } = arg;
    dispatch((0, document_1.setIsLoading)(true));
    const response = yield (0, update_document_elements_1.update_document_elements)(Object.assign({}, data));
    dispatch((0, document_1.setIsLoading)(false));
    if (response.success) {
        // dispatch(updateSelectedDocumentElements(data));
        dispatch((0, document_1.resetChangedElement)());
        if (!suppressModal) {
            dispatch((0, main_1.setMessageModal)({ title: "Success!", messages: ["Successfully saved the document elements."] }));
        }
        if (callback)
            callback();
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
}));
